import React from "react";
import PropTypes from "prop-types";

const MetaAdsReconnectBanner = ({ csrfToken }) => (
  <div
    role="alert"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      padding: "12px 16px",
      marginBottom: 16,
      background: "var(--sl-bg-warning-primary)",
      border: "1px solid var(--sl-border-warning)",
      borderRadius: 8,
      color: "var(--sl-text-warning)",
      fontSize: 14,
      lineHeight: 1.5,
    }}
  >
    <span>
      <strong>Reconnect required.</strong> We&rsquo;ve updated our Meta integration, so your
      connection needs to be re-authorized. Ad performance won&rsquo;t sync until you reconnect.
    </span>
    <form action="/users/auth/facebook" method="post" style={{ margin: 0, flexShrink: 0 }}>
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      <button type="submit" className="btn btn-setlist-primary">
        Reconnect
      </button>
    </form>
  </div>
);

MetaAdsReconnectBanner.propTypes = {
  csrfToken: PropTypes.string,
};

export default MetaAdsReconnectBanner;
